import { supabase } from './supabaseClient';
import { isVardiyaMuduru } from './staffRoleUtils';

export function normalizeShopIds(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val.map(String).filter(Boolean);
  return [];
}

export function buildShopAssignmentUpdates(allRows, staffId, shopId, assign) {
  const shopKey = String(shopId);
  const target = allRows.find((r) => r.id === staffId);
  if (!target) return [];

  const updates = new Map();
  const queue = (row, nextIds) => {
    const next = [...new Set(nextIds.map(String))];
    const cur = normalizeShopIds(row.assigned_shop_ids);
    if (JSON.stringify([...next].sort()) !== JSON.stringify([...cur].sort())) {
      updates.set(row.id, next);
    }
  };

  for (const row of allRows) {
    const ids = normalizeShopIds(row.assigned_shop_ids);
    if (row.id === staffId) {
      if (assign && !ids.includes(shopKey)) queue(row, [...ids, shopKey]);
      if (!assign && ids.includes(shopKey)) queue(row, ids.filter((id) => id !== shopKey));
    } else if (
      assign
      && isVardiyaMuduru(target)
      && isVardiyaMuduru(row)
      && ids.includes(shopKey)
    ) {
      queue(row, ids.filter((id) => id !== shopKey));
    }
  }

  return [...updates.entries()].map(([id, assigned_shop_ids]) => ({ id, assigned_shop_ids }));
}

export async function persistShopAssignmentUpdates(updates) {
  const saved = [];
  for (const u of updates) {
    const { data, error } = await supabase
      .from('staff_directory')
      .update({ assigned_shop_ids: u.assigned_shop_ids })
      .eq('id', u.id)
      .select()
      .single();
    if (error) throw error;
    saved.push(data);
  }
  return saved;
}
